import { store } from '../'
import { router } from '../../app';

const state = () => ({
    sites: [
        {
            label: 'HQ / Warehouse',
            value: 'WHQ', // v
            Id: process.env.MIX_SITE_HQ_ID, // v
            inTransitLocId: 'INTR',
        },
        {
            label: 'Soho',
            value: 'RSO', //
            Id: process.env.MIX_SITE_SOHO_ID, // v
            inTransitLocId: 'INTR',
        },
        {
            label: 'Beverly Hills',
            value: 'RBH', // v
            Id: process.env.MIX_SITE_BH_ID, // v
            inTransitLocId: 'INTR', // v
        },
        {
            label: 'Wooster',
            value: 'RWO', // v
            Id: process.env.MIX_SITE_WOOSTER_ID, // v
            inTransitLocId: 'INTR', // v
        }
    ],
    // Used with hidden input in order to determine barcode type.
    hidden: '',

    // "show" determines which tab to view.
    show: 'single',

    // "single" refers to states only on the "single items" tab.
    singleSkuVal: '',
    singleNotice: '',
    singleQuery: [{'test':'testValue'}],
    singleBin: '',
    singleLocid: '',
    singleLocnum: '',

    // "multi" refers to states only used on the "multiple items" tab.
    multiSkuVal: '',
    multiNotice: '',
    multiQuery: [],
    multiBin: '',
    multiLocid: '',
    multiLocnum: '',
    division: 'USD01',
    constants: {
        rstk__sydata_txnid__c: 'INVSITESITE',
        rstk__sydata_txntype__c: 'Inventory Transfer',
    },
    selectedID: '',
    selectedSite: {
        label: 'HQ / Warehouse',
        value: 'WHQ', // v
        Id: process.env.MIX_SITE_HQ_ID, // v
        inTransitLocId: 'INTR',
    },
    middleware: {
        URL: process.env.MIX_JIMI_HOST,
        api_token: 'token'
    },
    notice: '',
    transactionSkus: [],
    targetBin: '',
    currentSite:'WHQ',
    currentOrders:[],
    currentWebOrders:[],
    currentWholesaleOrders:[],
    currentOrderDetails:{},
    currentOrderByBin:[],
    missingFromCurrentOrder:[],
    siteOpenTransfers:[],
    selectedTransfer: '',
    itemsInCurrentTransfer: [],
    ordersInPick:[],
    currentScannedItemOrderDetails: [],
    scannedItemsForTransfer:[],
    locationSearchValue:'',
    lastSkuScanned: '',
    loaActive: true

});

const getters = {
    sites: state => state.sites,
    hidden: state => state.hidden,
    show: state => state.show,
    singleSkuVal: state => state.singleSkuVal,
    singleNotice: state => state.singleNotice,
    singleQuery: state => state.singleQuery,
    singleBin: state => state.singleBin,
    singleLocid: state => state.singleLocid,
    singleLocnum: state => state.singleLocnum,
    selectedID: state => state.selectedID,
    


    multiSkuVal: state => state.multiSkuVal,
    multiNotice: state => state.multiNotice,
    multiQuery: state => state.multiQuery,
    multiBin: state => state.multiBin,
    multiLocid: state => state.multiLocid,
    multiLocnum: state => state.multiLocnum,
    division: state => state.division,
    constants: state => state.constants,
    selectedID: state => state.selectedID,
    selectedSite: state => state.selectedSite,
    middleware: state => state.middleware,
    notice: state => state.notice,
    transactionSkus: state => state.transactionSkus,
    targetBin: state => state.targetBin,
    currentSite: state => state.currentSite,
    currentOrders: state => state.currentOrders,
    currentWebOrders: state => state.currentWebOrders,
    currentWholesaleOrders: state => state.currentWholesaleOrders,
    currentOrderDetails: state => state.currentOrderDetails,
    currentOrderByBin: state => state.currentOrderByBin,
    missingFromCurrentOrder: state => state.missingFromCurrentOrder,
    siteOpenTransfers: state => state.siteOpenTransfers,
    selectedTransfer: state => state.selectedTransfer,
    itemsInCurrentTransfer: state => state.itemsInCurrentTransfer,
    ordersInPick: state => state.ordersInPick,
    currentScannedItemOrderDetails: state => state.currentScannedItemOrderDetails,
    locationSearchValue: state => state.locationSearchValue,
    lastSkuScanned: state => state.lastSkuScanned,
    loaActive: state => state.loaActive,
    scannedItemsForTransfer: state => state.scannedItemsForTransfer
};

const mutations = {
    updateState(state, payload){ 
        //console.log('mutation called: '+ payload.field + ' = ' + payload.value);
        state[payload.field] = payload.value 
    }
};
const actions = {
    set({ state, commit, dispatch }, payload) {
        //console.log('action called: '+ payload.field + ' = ' + payload.value);
        commit('updateState', { field: payload.field, value: payload.value })
        if (payload.field == 'currentSite') {
            store.dispatch('ProductCollection/set', { field: 'currentLocation', value: payload.value });
            let currentSite = state.sites[state.sites.findIndex(x => x.value == payload.value)]
            commit('updateState', { field: 'selectedSite', value: currentSite })
        }
    },
    _return_tab_variables({ state }) {
        const isSingle = state.show === 'single'
        return (
            {
                sku: isSingle ? 'singleSkuVal' : 'multiSkuVal',
                query: isSingle ? 'singleQuery' : 'multiQuery',
                locid: isSingle ? 'singleLocid' : 'multiLocid',
                locnum: isSingle ? 'singleLocnum' : 'multiLocnum',
                notice: isSingle ? 'singleNotice' : 'multiNotice',
                bin: isSingle ? state.singleBin : state.multiBin
            }
        )
    },
    _setup_post_array({ dispatch, state }, selectedSkus) {
        //console.log('_setup_post_array  - in store.js')
        return new Promise((resolve, reject) => {
            const variables = dispatch('_return_tab_variables');
            //console.log('selected: '+ JSON.stringify(selectedSkus));
            //console.log('variables: '+ JSON.stringify(variables));
            //console.log('parsed: ' + [`${variables.query}`]);
            //console.log('item: '+ this[`${variables.query}`]);
            // let item = this.selectedSkus
            let posts = selectedSkus.map((item, index) => {
                return {
                    name: 'InventoryTransfer',
                    req_ref: Math.random(),
                    product: {
                        sku: encodeURIComponent(selectedSkus[index].sku),
                        img: selectedSkus[index].image
                    },
                    params: {
                        // Invventory transfer - TODO: Combine with 'missing'
                        item: encodeURIComponent(selectedSkus[index].sku),
                        type: 'INVLOCLOC',
                        quantity: selectedSkus[index].qty,
                        from_div: state.division,
                        from_site: item.siteId,
                        to_div: state.division,
                        to_site: state.selectedSite.Id,
                        from_locid: `${state.division}_${item.site}_${item.locId}`,
                        to_locid: `${state.division}_${state.selectedSite.value}_${item.toLocId}`,
                        from_proj: item.proj,
                        to_proj: item.proj,
                        from_locnum: item.locNum,
                        to_locnum: item.toLocNum, // For "mark item as missing:"  "shortship"
                    }
                }
            })
            //console.log('posts - ', posts)
            resolve(posts)
        })
    },
    async fetchLocationValidation({ state, dispatch }, payload) {
        //console.log('enteredlocation', payload)
        let testingPayload = await this._vm.$api.get('/api/salesforce/validateLocation/' + state.currentSite + '/' + payload)
            .then((response) => {
                //console.log('loaction validation response - ', response);
                return response;
            });
        return testingPayload
    },
    fetchItemsInTransfer({ state, dispatch }, transferId) {
        //('fetchItems in transfer called: - ', transferId)
        let transferItems = [];
        let allItems = this._vm.$api.get('/api/salesforce/transferItems/' + transferId)
            .then((response) => {
                // console.log('items in transfer: - ', response)
                response.forEach(item => {
                    let transferItem = {
                        id: item.Id,
                        sku: item.Item__r.rstk__icitem_item__r.rstk__peitem_item__c,
                        proj: item.savedProject__c,
                        qty: item.Qty__c,
                        qtySent: item.Quantity_Sent__c,
                        qtyReceived: item.Quantity_Received__c
                    };
                    transferItems.push(transferItem);
                })
                dispatch('set', { field: 'itemsInCurrentTransfer', value: transferItems });

            });
    },
    _post({ state }, payload) {
        //console.log('payload sent to post - '+JSON.stringify(payload));
        return new Promise((resolve, reject) => {
            Promise.all(payload.postArray.map(async newPayload => {
                //myToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                //console.log('post function - powerscan.js: '+ JSON.stringify(newPayload));
                //console.log('my token: '+  payload.myToken )
                newPayload.api_token = 'token';
	                
                try {
		            
                    if (typeof newPayload.params.user == 'undefined' || newPayload.params.user == null) {
                        newPayload.params.user = store.getters['Auth/name'];
                    }
		            
                } catch (e) {
                    // fail silently
                    console.log(e);
                }
	                            
                
                
                //console.log('new payload - '+ JSON.stringify(newPayload))
                const response = await fetch('https://' + process.env.MIX_JIMI_HOST + '/api/v1', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(newPayload)
                });
                return await response.json();
            })).then(jsons => {
                resolve(jsons.map(json => {
                    return {
                        response: json,
                        newPayload: payload.postArray.find(newPayload => newPayload.req_ref === json.req_ref).params
                    }
                }))
            })
        });
    },
    transferInventory({ state, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            //console.log('transfer payload - ', payload);
            let requestID = payload.req_ref;
            let currentNotification = {};
            try {
	            
                if (typeof payload.params.user == 'undefined' || payload.params.user == null) {
                    payload.params.user = store.getters['Auth/name'];
                }
	            
            } catch (e) {
                // fail silently
                console.log(e);
            }
            
            fetch('https://' + process.env.MIX_JIMI_HOST + '/api/v1', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    //console.log('psjs response - ', data);
                    let itemID = payload.params.rstk__soprod_prod__c ? payload.params.rstk__soprod_prod__c : payload.params.item
                    let ToastName = payload.name.replace(/([A-Z])/g, ' $1');
                    let ToastIcon = payload.name.includes('ransfer') ? 'ItemTransfersIcon' : 'BoxReceivingIcon';
                    let ToastTransaction = '';
                    switch (payload.name) {
                        case 'PickItem': ToastTransaction = 'Pick'; break;
                        case 'ItemTransfer': ToastTransaction = 'Transfer'; break;
                        default: ToastTransaction = 'Transfer';
                    }

                    store.dispatch('Navigation/addPendingNotification', {
                        icon: ToastIcon,
                        header: ToastName,
                        message: ToastName + ': ' + itemID,
                        type: 'pending...',
                        reference: data.id,
                        product: payload.product,
                        transactionType: ToastTransaction
                    }).then((response) => {
                        //console.log('Notification response - '+ JSON.stringify(response));
                        currentNotification = response;
            
                    });
                    getData(data);
                    async function getData(data) {
                        const pollData = await dispatch('_checkTransfer', { reqID: data.req_ref, id: data.id })
                            .then((response) => {
                                if (response.data.status == 'ready' || response.data.status == 'prepared') {
                                    setTimeout(getData, 5000, data)
                                } else {
                                    //console.log('done?' + JSON.stringify(response.data));
                                    let status = response.data.response ? response.data.response : 'success'
                                    let message = '';
                                    if (status.includes('rror')) {
                                        //status = currentNotification.transactionType + ' Failed - ref id: '+ response.data.id
                                        message = currentNotification.transactionType == 'Pick' ? 'Could Not ' + currentNotification.transactionType : 'Unable to ' + currentNotification.transactionType
                                    } else {
                                        message = 'Successful ' + currentNotification.transactionType;
                                    }
                                    store.dispatch('Navigation/addNotification', {
                                        icon: status == 'error' ? 'NotificationError' : currentNotification.icon,
                                        header: currentNotification.header,
                                        message: message,
                                        type: response.data.status,
                                        reference: response.data.id,
                                        product: currentNotification.product,
                                        status: status,
                                        transactionType: currentNotification.transactionType
                                    });
                                    if (response.data.status == 'error') {
                                        console.log('transfer failed - ' + currentNotification.message)
                                        //alert('transfer failed - '+ currentNotification.message)
                                    }
                                    store.dispatch('Navigation/removePendingNotification', currentNotification);
                                    //clearTimeout(getData);
                                    resolve(response.data);
                                }
                            });
                    };
                });
        });
    },
    logLOATransaction({ state, dispatch }, payload) {
        fetch('https://' + process.env.MIX_JIMI_HOST + '/api/v1', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
    },
    async _checkTransfer({ state, dispatch }, payload) {
        return await new Promise((resolve, reject) => {
            fetch('https://' + process.env.MIX_JIMI_HOST + '/api/v1/status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    req_ref: payload.reqID,
                    api_token: 'token'
                })
            })
                .then(response => response.json())
                .then(data => {
                    resolve(data);
                });
        });
    },
    
    _query({ dispatch, state }) {
        return new Promise((resolve, reject) => {
            let { target, notice, sku } = ''
            dispatch('set', { field: 'singleQuery', value: [] });
            if (state.show === 'single') {
                target = 'singleQuery', notice = 'singleNotice', sku = 'singleSkuVal'
            } else {
                target = 'multiQuery', notice = 'multiNotice', sku = 'multiSkuVal'
            }
            //console.log('insert api call to check for the product existing elsewhere');
            const query = `SELECT rstk__externalid__c, rstk__iclocitem_site__r.rstk__externalid__c, rstk__iclocitem_proj__c, rstk__iclocitem_site__c FROM rstk__iclocitem__c WHERE rstk__iclocitem_icitem__r.rstk__externalid__c = '${this.division}_${this.sku}'`
            //This needs to be an api call that checks the transactions for duplicates
            /* net.query(query,
                (response) => {
                    const recs = response.records
                    let proceed = false
                    if (recs.length > 0) {
                        recs.map(item => {
                            if (item.rstk__iclocitem_site__r.rstk__externalid__c === `${config.division}_${state.selectedSite}`) {
                                proceed = true
                            }
                        })
                    }
                    if (proceed) {
                        this.setState(prevState => ({
                            [target]: [...prevState[target], response.records[0]]
                        }))
                        this.setState({ [notice]: '' })
                        resolve('item site verified')
                    }else{
                        reject('Item is not currently located in your selected site.')
                    }
                },
                (error) => {
                    reject('_query error: ' + error)
                },
            ); */
            return 'For now lets say there are no duplicates in other transactions'
        });


        promise.then((message) => {
            console.log(message)
            console.log('[target]', state[target])
        })
    },
    parseOrders({ commit, getters, dispatch }, payload) {
        let webOrders = [];
        let whOrders = [];
        payload.forEach((order) => {
            //console.log('Order Name: ', order['Name']);
            if (order['Name'].indexOf('WEB') !== -1) {
                webOrders.push(order);
            } else if (order['Name'].indexOf('WH-') !== -1) {
                whOrders.push(order);
            }
        });
        dispatch('set', { field: 'currentWebOrders', value: webOrders });
        dispatch('set', { field: 'currentWholesaleOrders', value: whOrders });
    },
    async fetchRecentOrders({ state }, payload) {
        return await new Promise((resolve, reject) => {
            let parsedRecentOrders = [];
            let recentOrders = this._vm.$api.get('/api/salesforce/openOrderLines')
                .then((response) => {
                    response.forEach((order) => {
                        let parsedOrder = {
                            Id: order.Id,
                            name: order.Name,
                            offerName: order.rstk__sohdr_quotesf__r.Name,
                            purchaseNo: order.rstk__sohdr_custpo__c,
                            lineId: order.rstk__solines__r.records[0].Id,
                            orderItems: []

                        };
                        order.rstk__solines__r.records.forEach((item) => {
                            let product = {
                                Id: item.Id,
                                sku: item.rstk__soline_prod__r.rstk__soprod_prod__c,
                                img: item.rstk__soline_prod__r.rstk__soprod_urlimage__c,
                                description: item.rstk__soline_prod__r.rstk__soprod_descr__c,
                                UPC: item.UPC__c == null ? 'N/A' : item.UPC__c,
                                toPick: item.Units_to_Pick__c,
                                offerName: parsedOrder.offerName,
                                purchaseNo: parsedOrder.purchaseNo,
                                orderNum: parsedOrder.name,
                                storeNum: item.Door__c == null ? 'N/A' : item.Door__c,
                                bin: (item.inventory != null && item.inventory.length > 0) ? item.inventory[0].rstk__iclocitem_locid__r.rstk__sylocid_locid__c + "_" + item.inventory[0].rstk__iclocitem_locnum__c : null
                            }
                            parsedOrder.orderItems.push(product);
                        });
                        parsedRecentOrders.push(parsedOrder);
                    });
                    //console.log('did this work? - ', JSON.stringify(parsedRecentOrders));
                    resolve(parsedRecentOrders)

                });
        });
    },
    fetchCurrentOrders({ commit, getters, dispatch }, payload) {
        //let searchSku = payload;
        let allOrders = this._vm.$api.get('/api/salesforce/openOrders')
            .then((response) => {
                //console.log('currentOrders from store:',JSON.stringify(response));
                dispatch('parseOrders', response)
            });

    },
    fetchOpenTransfers({ commit, getters, state, dispatch }) {
        //('fetching orders')
        let openTransfers = [];
        let allOrders = this._vm.$api.get('/api/salesforce/openTransfers/' + state.currentSite)
            .then((response) => {
                //console.log('currentTransfers from store:',JSON.stringify(response));
                //dispatch('parseOrders', response)
                response.forEach(item => {
                    let openTransfer = {
                        value: item.Id,
                        label: item.Name + "    (Items: " + (item.Shipped_Count__c - item.Received_Count__c) + ')',
                        shipped: item.Shipped_Count__c,
                        received: item.Received_Count__c
                    };
                    if ((openTransfer.shipped - openTransfer.received) > 0) {
                        openTransfers.push(openTransfer);
                    }
                })
                dispatch('set', { field: 'siteOpenTransfers', value: openTransfers });
            });
    },
    checkDuplicateLOA({ commit, dispatch }, payload) {
        //console.log(payload)
        let loaNum = payload.loa.split('/').pop();
        console.log('loa? - '+loaNum)
        return new Promise((resolve, reject) => {
            fetch('https://' + process.env.MIX_LLV3_HOST + '/powerscan/checkDuplicateLOA', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(response => response.json())
                .then(data => {
                    //console.log('data? ', data);
                    if (data.duplicate > 0) {
                        store.dispatch('Navigation/addNotification',{
                                icon: data.duplicate,
                                header: "Failed LOA Pairing",
                                message: 'Duplicate LOA' + ': ' + loaNum,
                                type: 'Error: Duplicate LOA',
                                status: 'error',
                                notificationObject:{
                                    status: 'Duplicate LOA'
                                },
                                reference: data.id,
                                product: {
                                    sku:payload.sku,
                                    img:payload.img
                                },
                                transactionType: 'Loa Pairing'
                        });
                    }
                    resolve(data);
                });
        });
    },
    assignLOA({commit, dispatch}, payload){
        //console.log(payload)
        return new Promise((resolve, reject) =>{
            fetch('https://' + process.env.MIX_LLV3_HOST + '/powerscan/setLOA', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }).then(response => response.json())
                    .then(data => {
                       // console.log('data? ', data);
                        if(data.results == 'error' || data.success == false){
                            store.dispatch('Navigation/addNotification',{
                                    icon: data.results,
                                    header: "Failed LOA Pairing",
                                    message: 'LOA' + ': ' + payload.loa,
                                    type: 'Error Pairing LOA',
                                    status: data.success == false ? 'error' : data.results,
                                    notificationObject:{
                                        status: data.results
                                    },
                                    reference: data.id,
                                    product: {
                                        sku:payload.sku,
                                        img:payload.img
                                    },
                                    transactionType: 'Loa Pairing'
                            });
                        }
                        resolve(data.success);
                });
            });   
    },
    fetchCurrentLocations({commit, state, getters, dispatch}, payload){
        //console.log('got to the store - ', payload)
        return new Promise((resolve, reject) => {
            let matchingLocs = this._vm.$api.get('/locations/'+ state.currentSite +'?q='+ payload)
                .then((response) => {
                    //console.log(' search locations? ', response);
                    resolve(response)
                });
        });
    },
    fetchOrderItems({commit, getters, dispatch}, payload){
        //console.log('fetching items - ', JSON.stringify(payload));
        return new Promise((resolve, reject) => {
            let orderDetails = this._vm.$api.get('/api/salesforce/orderPickInfo/'+ payload.Id)
                .then((response) => {
                    //console.log('OrderItemInfo from store:',JSON.stringify(response));
                    let OrderOffer = '';
                    //let OrderStoreNum = '';
                    let currentOrder =  {
                        name: response.Name,
                        custPo: response.rstk__sohdr_custpo__c,
                        offerName: response.rstk__sohdr_quotesf__r.Name,
                        orderItems: []
                    }
                    //OrderOffer = current
                    let theseItems = response.rstk__solines__r.records;
                    //console.log('these items', theseItems);
                    theseItems.forEach(item =>{
                        let product = {
                            Id: item.Id,
                            sku: item.rstk__soline_prod__r.rstk__soprod_prod__c,
                            img: item.rstk__soline_prod__r.rstk__soprod_urlimage__c,
                            description: item.rstk__soline_prod__r.rstk__soprod_descr__c,
                            UPC: item.UPC__c,
                            toPick: item.Units_to_Pick__c,
                            offerName: currentOrder.offerName,
                            storeNum: item.Door__c,
                            bin: (item.inventory != null && item.inventory.length > 0) ? item.inventory[0].rstk__iclocitem_locid__r.rstk__sylocid_locid__c +"_"+ item.inventory[0].rstk__iclocitem_locnum__c : null
                        }
                        //if(product.toPick == 0){
                            currentOrder.orderItems.push(product)
                        //}
                    });
                    resolve(currentOrder)
                    
                });
            });
    },
    fetchOrderDetails({commit, getters, dispatch}, payload){
        //console.log('fetching details - ', JSON.stringify(payload));
        let orderDetails = this._vm.$api.get('/api/salesforce/orderPickInfo/'+ payload.Id)
            .then((response) => {
                //console.log('OrderPickInfo from store:',JSON.stringify(response));
                let myOrderDetails = {
                    custName : response.rstk__sohdr_custno__r.rstk__socust_sf_account_name__c,
                    custPo : response.rstk__sohdr_custpo__c,
                    offer : ((response.rstk__sohdr_quotesf__r != null) ? response.rstk__sohdr_quotesf__r.Name : ''),
                    orderNum: payload.Name,
                    orderId: response.Id,
                    fullDetails: response,
                    numOfItems:response.rstk__solines__r.records.length
                };
                response.rstk__solines__r.offer = myOrderDetails.offer;
                dispatch('getBins', response.rstk__solines__r);
                dispatch('set', {field: 'currentOrderDetails', value:myOrderDetails});
            });
    },
    getBins({commit, getters, dispatch}, payload){
        //console.log('getting bins?', typeof(payload));
        let OrderByBin = [];
        payload.records.forEach((item)=>{
            //console.log('bin item info: ',JSON.stringify(item.inventory[0]));
            //console.log('bin item info: ', item);
            if(item.Units_to_Pick__c > 0){
           // console.log('is this a bin?: '+ JSON.stringify(item.inventory[0].rstk__iclocitem_locid__r.rstk__sylocid_locid__c + '_' + item.inventory[0].rstk__iclocitem_locnum__c));

                let binString = 'UNKN_BIN';
                let product = {
                    sku: item.rstk__soline_prod__r.rstk__soprod_prod__c,
                    description: ((item.Customer_Description__c == null || item.Customer_Description__c == '') ? item.rstk__soline_prod__r.rstk__soprod_descr__c : item.Customer_Description__c),
                    door: item.Door__c,
                    image: item.rstk__soline_prod__r.rstk__soprod_urlimage__c,
                    productOrderId: item.Id,
                    //productInventory: item.inventory,
                    offer: payload.offer,
                    siteId: '',
                    loc_num: '',
                    loc_id: '',
                    proj: ''
                }
                if (item.inventory != null && item.inventory.length > 0) {
                    binString = item.inventory[0].rstk__iclocitem_locid__r.rstk__sylocid_locid__c + '_' + item.inventory[0].rstk__iclocitem_locnum__c;
                	product = Object.assign(product, {                	
						siteId: item.inventory[0].rstk__iclocitem_site__c,
						loc_num: item.inventory[0].rstk__iclocitem_locnum__c,
						loc_id: item.inventory[0].rstk__iclocitem_locid__r.rstk__sylocid_locid__c,
						proj: item.inventory[0].rstk__iclocitem_proj__c
                    });
                }
                if(OrderByBin.findIndex(x => x.bin == binString) == -1){
                    //console.log('adding: - ', binString)
                    OrderByBin.push({
                        bin:binString,
                        products:[product]
                    });
                }else{
                    //console.log('adding product to: - ', binString)
                    OrderByBin[OrderByBin.findIndex(x => x.bin == binString)].products.push(product);
                }
                if (binString == 'MISS_SHORTSHIP'){
                    //console.log('moving missing products');
                    let missingProducts = getters['missingFromCurrentOrder'];
                    missingProducts.push(product);
                    dispatch('set', {field: 'missingFromCurrentOrder', value: missingProducts});
                }
            }
        });
        //console.log("here's order by bin");
        //console.log(OrderByBin);
        
        OrderByBin.sort((a, b) => {  
	        var val1 = a.bin; 
	        var val2 = b.bin;   
	        if ((val1 === null || val2 === null) || (typeof val1 != typeof val2)) {
		        return null;
		    }
		    if (typeof val1 === 'string') {
		        return (val1).localeCompare(val2);
		    }
		    else {
		        if (val1 > val2) { return 1 }
		        else if (val1 < val2) { return -1 }
		        return 0;
		    }
        });

        //console.log("here's order by bin again");
        //console.log(OrderByBin);
        
        dispatch('set', {field: 'currentOrderByBin', value: OrderByBin});
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
